import React from 'react';
import styles from './ReviewsStatsCard.module.scss';
import clx from 'classnames';
import { Rating } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from 'assets/svg/icons/stella.svg';

const ReviewsStatsCard = ({ reviewsStats, isMobile }) => {
  const { t } = useTranslation();
  const { averageRating, totalReviews, ratingDistribution } = reviewsStats || {};

  // Ordina le stelle da 5 a 1
  const starRatings = [5, 4, 3, 2, 1];

  // Calcola le percentuali dal totale recensioni (non dal maxCount)
  const calculatePercentage = (stars) => {
    const count = parseInt(ratingDistribution?.[stars.toString()] || 0);
    return totalReviews > 0 ? (count / totalReviews) * 100 : 0;
  };

  return (
    <div
      className={clx(styles.stats_card, {
        [styles.stats_card_mobile]: isMobile,
      })}
    >
      <div className={styles.stats_header}>
        {/* Sezione sinistra: Media totale e Totale recensioni */}
        <div className={styles.left_section}>
          <div className={styles.average_rating_section}>
            <div className={styles.average_rating_value}>
              {averageRating?.toFixed(1) || '0.0'}
            </div>
            <div className={styles.star_icon}>
              <Rating 
                value={averageRating} 
                readOnly 
                precision={0.1}
                size="large"
                sx={{
                  '& .MuiRating-iconFilled': {
                    color: '#858AF9',
                  },
                  '& .MuiRating-iconEmpty': {
                    color: '#858AF9',
                  },
                }}
              />
            </div>
          </div>
          <div className={styles.total_reviews_section}>
            <div className={styles.total_reviews_value}>
              {totalReviews}
            </div>
            <div className={styles.total_reviews_value_label}>
              {t('reviews.stats.totalReviewsLabel')}
            </div>
          </div>
        </div>

        {/* Sezione destra: Distribuzione per stelle con percentuali */}
        <div className={styles.rating_distribution_section}>
          {starRatings.map((stars) => {
            const percentage = calculatePercentage(stars);

            return (
              <div key={stars} className={styles.rating_row}>
                <div className={styles.stars_display}>
                  <Rating
                    value={stars}
                    readOnly
                    size="small"
                    precision={1}
                    sx={{
                      '& .MuiRating-iconFilled': {
                        color: '#000000',
                      },
                      '& .MuiRating-iconEmpty': {
                        color: '#E0E0E0',
                      },
                    }}
                  />
                </div>
                <div className={styles.bar_container}>
                  <div
                    className={styles.bar_filled}
                    style={{ width: `${percentage}%` }}
                  />
                  <div className={styles.bar_empty} />
                </div>
                <div className={styles.percentage_display}>
                  {percentage.toFixed(0)}%
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ReviewsStatsCard;
